import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
import { Button, Input, CloseIcon } from "components";
import { UpdateAuthData, MobileOtp, SendMailOtp, VerifyEMailOtp, VerifyMobileOtp } from "redux/features/LoginSlice";

const OtpVerification = ({ handleChange }) => {
  const dispatch = useDispatch();
  const { authData, authActionsData } = useSelector(
    (state) => state?.LoginReducer
  );

  const [seconds, setSeconds] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [loginDetails, setLoginDetails] = useState({ otp: '' });

  useEffect(() => {
    if (authData?.success) {
      setIsLoading(false);
      dispatch(UpdateAuthData(''));
      handleChange('username');
    } else if (!authData?.success) {
      setIsLoading(false);
    }
  }, [authData]);

  const handleFieldChange = useCallback((data, name) => {
    if(name === 'otp') {
      if (data.length > 6) {
        data = data.slice(0, 6);
      }
    }
    setLoginDetails((prevState) => ({
      ...prevState,
      [name]: data,
    }));
  }, []);

  const handleSubmit = () => {
    const payload = {
      sid: authActionsData?.sid,
      userPassword: authActionsData?.password,
      otp: loginDetails.otp,
    };
    setIsLoading(true);
    if (isFormValid) {
      if (authActionsData?.type === 'mobile') {
        payload.phoneNo = authActionsData?.phoneNo;
        dispatch(VerifyMobileOtp(payload));
      } else {
        payload.userEmail = authActionsData?.email;
        dispatch(VerifyEMailOtp(payload));
      }
    }
  };

  const SendAgainOtp = () => {
    if (authActionsData?.type === 'mobile') {
      dispatch(MobileOtp(authActionsData, true, true));
    } else {
      dispatch(SendMailOtp(authActionsData, true, true));
    }
    setSeconds(30);
  };

  useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [seconds]);

  const isFormValid = () => {
    const { otp } = loginDetails;
    return otp.length === 6;
  };

  return (
    <>
      <div className="card-title">
        <CloseIcon
          iconType="back"
          customStyle="back_btn"
          onClick={() => {
            handleChange('SignUp');
            dispatch(UpdateAuthData(''));
          }}
        />
        {t('Auth.VerificationCode')}
      </div>
      <div className="helper-title">
        {t('Auth.SentCode')} <br /> {t('Auth.VerifyCode')}
      </div>
      <div className="otp-field">
        <Input type={"number"} maxLimit={6} value={loginDetails.otp} onChange={(data) => handleFieldChange(data, "otp")} />
      </div>
      <div className="otp-resend">
        <span>{t('Auth.DontReceive')}</span>
        {seconds === 0 ? (
          <a onClick={SendAgainOtp}>{t('Auth.SendAgain')}</a>
        ) : (
          <div>{seconds}s</div>
        )}
      </div>
      <Button
        label={t('Auth.SignUp')}
        disabled={!isFormValid()}
        onClick={isFormValid() ? handleSubmit : () => {}}
        customStyles="auth-action-btn"
        loading={isLoading}
        loadingIndicator="Loading…"
      />
    </>
  );
};

export default OtpVerification;
